import React from "react";
import { Col, Form } from "react-bootstrap";
import { useQuery } from "react-query";
import { getDelivery } from "../../../MyApi/delivery";

const CompanyFilter = ({ filters, handleChange }) => {
  const { data } = useQuery("getDelivery", getDelivery);
  const delivery_company = data?.data?.delivery_company || [];

  return (
    <Col xs="auto">
      <Form.Select
        value={filters.company || ""}
        onChange={(e) => handleChange("company", e.target.value)}
      >
        <option value="">الشركة</option>
        {delivery_company.map((company) => (
          <option key={company.id} value={company.id}>
            {company.name}
          </option>
        ))}
      </Form.Select>
    </Col>
  );
};

export default CompanyFilter;